import { LinkButton, Theme, useDeviceType } from '@cian/ui-kit';
import { CustomSlider } from '../CustomSlider';
import * as styles from './styles.css';
import { ADD_ADVERTISING, BOOKING_RULES } from 'shared/constants/links';
import { useUrlWithUtm } from 'shared/hooks';
import { clsx } from 'clsx';
import { NBSP } from 'shared/constants/symbols';
import { caPlaceAnAd } from '../tracking';

export const HowConnectOnlineBooking: React.FC = () => {
  const device = useDeviceType();
  const advertisingUrl = useUrlWithUtm(ADD_ADVERTISING);

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['wrapper']}>
        <div className={styles['title']}>
          Как начать работу{NBSP}с{NBSP}сервисом
        </div>
        <CustomSlider />
        <div className={styles['notice-block']}>
          <div className={styles['image']} />
          <div className={styles['notice-textblock']}>
            <div className={styles['notice-title']}>Играйте по правилам — работайте без стресса</div>
            <div className={styles['notice-text']}>
              Соблюдайте{' '}
              <a className={styles['link']} href={BOOKING_RULES}>
                правила работы с онлайн- бронированием
              </a>
              , чтобы защитить себя и свой доход
            </div>
            <div className={styles['btn']}>
              <Theme theme="onOverlay">
                <LinkButton
                  theme="fill_secondary"
                  href={advertisingUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={caPlaceAnAd}
                  fullWidth
                  size="L"
                >
                  Разместить объявление
                </LinkButton>
              </Theme>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
